/* eslint-disable react-hooks/exhaustive-deps */
import { LayoutRoute } from 'components/Layout';
import HomePublicaLayout from 'components/Layout/HomePublica';
import React, { lazy } from 'react';
import { PymesGeneral } from './constantes/general';

/**
 * @description Definición de rutas para el módulo Pymes.
 * Cada ruta tiene un path, un componente asociado, y otras configuraciones relevantes.
 */
const ROUTES = [
  {
    path: `${PymesGeneral.urls.datosPersonales}/:idCotizacion?`,
    component: lazy(() => import('./PymesAsegurado')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.datosGenerales}/:idCotizacion?`,
    component: lazy(() => import('./PymesInfoGeneral')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.datosUbicaciones}/:idCotizacion?/:idUbicacion?`,
    component: lazy(() => import('./PymesUbicaciones')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.datosResumen}/:idCotizacion?`,
    component: lazy(() => import('./PymesResumen')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.emisionContratante}/:idPoliza`,
    component: lazy(() => import('./emision/PymesEmisionContratante')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.emisionAsegurado}/:idPoliza`,
    component: lazy(() => import('./emision/PymesEmisionAsegurado')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.pagoPoliza}/:idPoliza`,
    component: lazy(() => import('./emision/PymesEmisionPago')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.vigenciaPoliza}/:idPoliza`,
    component: lazy(() => import('./emision/PymesVigenciaPoliza')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `${PymesGeneral.urls.finCompra}/:idPoliza`,
    component: lazy(() => import('./emision/PymesFinCompra')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `/recuperar-cotizacion-pymes`,
    component: lazy(() => import('./RecuperarPymes')),
    loginRequired: false,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `/presuscrito-ubicacion`,
    component: lazy(() => import('./Presuscritos/PresuscritoUbicacion')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `/presuscrito-planes`,
    component: lazy(() => import('./Presuscritos/PresuscritoPlanes')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `/presuscrito-resumen`,
    component: lazy(() => import('./Presuscritos/PresuscritoResumen')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `/presuscrito-contratante`,
    component: lazy(() => import('./Presuscritos/PresuscritoContratante')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `/presuscrito-asegurado`,
    component: lazy(() => import('./Presuscritos/PresuscritoAseguradoEmision')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
  {
    path: `/presuscrito-pago`,
    component: lazy(() => import('./Presuscritos/PresuscritoPago')),
    loginRequired: true,
    exact: true,
    navBarTab: 'empresas',
    layout: HomePublicaLayout,
    RouteComponent: LayoutRoute,
  },
];

/**
 * @description Mapea las rutas definidas y las convierte en componentes de ruta.
 */
const PYMES_ROUTES = ROUTES.map((route) => <route.RouteComponent key={route.path} {...route} />);

export default PYMES_ROUTES;
